import React from 'react';
import {  
  graphql,
} from 'react-relay';

class Dummy extends React.Component {
  render() {
    return <span/>
  }
}

export default Dummy

